import { render, staticRenderFns } from "./AccountingPointTable.vue?vue&type=template&id=71c4d0c8&"
import script from "./AccountingPointTable.vue?vue&type=script&lang=ts&"
export * from "./AccountingPointTable.vue?vue&type=script&lang=ts&"
import style0 from "./AccountingPointTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports